exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.mv-22 {\n  margin: 22px 0;\n}\n.v-middle {\n  vertical-align: middle !important;\n}\n.filter-btn {\n  color: #fff;\n  padding: 4px 8px;\n  margin-right: 5px;\n  border-radius: 4px;\n  transition: all .3s;\n}\n.filter-btn:last-child{\n  margin-right: 0;\n}\n.btn-promoter {\n  background: #28A745;\n}\n.btn-promoter:hover {\n  background: #1e7b33;\n}\n.btn-neutral {\n  background: #F8C107;\n}\n.btn-neutral:hover {\n  background: #b18905;\n}\n.btn-detractor {\n  background: #DC3545;\n}\n.btn-detractor:hover {\n  background: #922630;\n}\n.btn-all {\n  background: #a0a0a0;\n}\n.btn-all:hover {\n  background: #797979;\n}\n", ""]);

// exports
